import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
import { UrgencyCountdown } from './UrgencyCountdown';
export function FinalCTA() {
  return <section className="w-full py-14 px-4 bg-base relative overflow-hidden" data-id="element-90">
      <div className="absolute inset-0 hero-glow pointer-events-none" data-id="element-91" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-92">
        <h2 className="text-4xl md:text-6xl font-extrabold text-text-main mb-6" data-id="element-93">
          El próximo lunes puede ser diferente.
        </h2>

        <p className="text-2xl md:text-3xl font-bold text-primary italic mb-16" data-id="element-94">
          "El próximo Reel puede ser el que genera tu primera venta del día." 💪
        </p>

        <div className="mb-16" data-id="element-95">
          <h3 className="text-2xl font-bold text-text-main mb-8" data-id="element-96">
            ⏰ NO ESPERES MÁS
          </h3>
          {/* Reusing the countdown logic visually, though ideally state would be lifted if strict sync is needed.
           For this static build, a second instance is fine as requested. */}
          <div className="scale-90 md:scale-100 origin-top" data-id="element-97">
            <UrgencyCountdown data-id="element-98" />
          </div>
        </div>

        <div className="flex flex-col gap-6 max-w-md mx-auto" data-id="element-99">
          <div className="bg-alt border border-primary/30 p-6 rounded-2xl" data-id="element-100">
            <h4 className="text-xl font-bold text-text-main mb-2" data-id="element-101">
              📘 KIT PACK
            </h4>
            <p className="text-2xl font-extrabold text-text-main mb-6" data-id="element-102">
              $19.990 ARS
            </p>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC7mdrcAxviHhOjvhF6VIA/es-ar?_r=AQABNiY6VVJWoEGLehotUaLJRhE3vrUooz0X390AtzyR1DE&cart_link_id=ojNS98B4&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="block w-full py-4 rounded-xl bg-cta/10 text-cta border border-cta/30 font-bold text-lg hover:bg-cta hover:text-base transition-colors duration-300 text-center" data-id="element-103">
              → QUIERO MI KIT PACK
            </a>
          </div>

          <div className="bg-alt border-2 border-primary p-6 rounded-2xl shadow-[0_0_30px_rgba(123,63,242,0.2)]" data-id="element-104">
            <h4 className="text-xl font-bold text-text-main mb-2" data-id="element-105">
              🏆 KIT PACK + NEGOCIO EN AUTOMÁTICO
            </h4>
            <p className="text-2xl font-extrabold text-text-main mb-6" data-id="element-106">
              $27.990 ARS
            </p>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC7mtjQnw4bIYc6Z4wbxtC/es-ar?_r=AQABAq3faZLqRgNe-Ll5TPWrDIp-W5u9n5uuDJOdghzSZt8&cart_link_id=nD9IkIWz&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="btn-glow block w-full py-4 rounded-xl bg-cta text-base font-bold text-lg uppercase tracking-wide hover:scale-[1.02] transition-transform duration-300 text-center" data-id="element-107">
              → QUIERO EL COMBO COMPLETO
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mt-12 text-sm text-text-muted" data-id="element-108">
          <span className="flex items-center gap-2" data-id="element-109">
            <Lock size={16} data-id="element-110" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-111">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-112">
            <Shield size={16} data-id="element-113" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-114">
            <CreditCard size={16} data-id="element-115" /> Mercado Pago — Tarjeta — Transferencia
          </span>
        </div>
      </div>
    </section>;
}